class GridsterPositions {
    constructor($localStorage, storageService) {
        this.$localStorage = $localStorage;
        this.storageService = storageService;
    }

    getGridsterPoitions() {
        const gridsterPoitionsId = 'gridsterPoitions-' + this.storageService.getUsername();
        return angular.isDefined(this.$localStorage[gridsterPoitionsId]) ? this.$localStorage[gridsterPoitionsId] : [];
    }

    setGridsterPoitions(gridsterPoitions) {
        const gridsterPoitionsId = 'gridsterPoitions-' + this.storageService.getUsername();
        this.$localStorage[gridsterPoitionsId] = gridsterPoitions;
    }
}

GridsterPositions.$inject = ['$localStorage', 'storageService'];

module.exports = GridsterPositions;


// WEBPACK FOOTER //
// ./src/azurebackup/services/gridsterPositions.service.js